import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import Dashboard from '@/pages/Dashboard';
import UploadCV from '@/pages/UploadCV';
import CandidatesList from '@/pages/CandidatesList';
import CandidateDetail from '@/pages/CandidateDetail';
import JobsList from '@/pages/JobsList';
import CreateJob from '@/pages/CreateJob';
import JobDetail from '@/pages/JobDetail';
import Login from '@/pages/Login';
import AuthCallback from '@/pages/AuthCallback';
import Navigation from '@/components/Navigation';
import ProtectedRoute from '@/components/ProtectedRoute';
import { AuthProvider } from '@/context/AuthContext';
import { Toaster } from 'sonner';

function AuthedLayout({ children }) {
  return (
    <ProtectedRoute>
      <Navigation />
      {children}
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            {/* Protected routes */}
            <Route path="/" element={<AuthedLayout><Dashboard /></AuthedLayout>} />
            <Route path="/upload" element={<AuthedLayout><UploadCV /></AuthedLayout>} />
            <Route path="/candidates" element={<AuthedLayout><CandidatesList /></AuthedLayout>} />
            <Route path="/candidates/:id" element={<AuthedLayout><CandidateDetail /></AuthedLayout>} />
            <Route path="/jobs" element={<AuthedLayout><JobsList /></AuthedLayout>} />
            <Route path="/jobs/new" element={<AuthedLayout><CreateJob /></AuthedLayout>} />
            <Route path="/jobs/:id" element={<AuthedLayout><JobDetail /></AuthedLayout>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
